import {
  useQuery, UseQueryResult,
} from '@tanstack/react-query';
import { getGroups } from '../../services/GroupsService';
import { GroupsResponse } from '../../types/Groups';
import { FeaturesManagement } from '../../../featuresControl';

function useGetGroups(fleetId: string, query: string): UseQueryResult<GroupsResponse> {
  return useQuery(
    ['groups', fleetId, query],
    async (): Promise<GroupsResponse> => getGroups(fleetId, query),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      refetchInterval: FeaturesManagement.productivity.refetchInterval,
    },
  );
}

export default useGetGroups;
